import { createSelector } from '@reduxjs/toolkit';
import { InvApplication } from '../interfaces';
import { getSecurityAttributes } from '../security/session.state';
import { determineApplicationAccessForSecurityAttributes } from './application.helpers';

const EMPTY_ARRAY: InvApplication[] = [];

export const getApplications = createSelector(
  [getSecurityAttributes],
  (securityAttributes) => {
    if (securityAttributes) {
      return determineApplicationAccessForSecurityAttributes(
        securityAttributes
      );
    }
    return EMPTY_ARRAY;
  }
);
